function containsOnlyLetters(value) {
    return /^[a-zA-Z\s]+$/.test(value);
}

export { containsOnlyLetters };
